var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoDeepBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#01313D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.142 12.7634H7.73859V9.53154H7.142C6.8125 9.53154 6.54541 9.33122 6.54541 9.0841V8.01536C6.54541 7.76824 6.8125 7.56792 7.142 7.56792H10.4829C10.8124 7.56792 11.0795 7.76824 11.0795 8.01536V12.7634H11.6761C12.0056 12.7634 12.2727 12.9637 12.2727 13.2108V14.2796C12.2727 14.5267 12.0056 14.727 11.6761 14.727H7.142C6.8125 14.727 6.54541 14.5267 6.54541 14.2796V13.2108C6.54541 12.9637 6.8125 12.7634 7.142 12.7634ZM9.40905 3.27246C8.22287 3.27246 7.26132 3.99363 7.26132 4.88326C7.26132 5.77289 8.22287 6.49405 9.40905 6.49405C10.5952 6.49405 11.5568 5.77289 11.5568 4.88326C11.5568 3.99363 10.5952 3.27246 9.40905 3.27246Z",
    fill: "#FAF4ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoDeepBlue);
export default __webpack_public_path__ + "static/media/info-deep-blue.282aa5238d87c7e348fdce626bd0f671.svg";
export { ForwardRef as ReactComponent };